<div role="alertdialog" aria-labelledby="idle-warning-title" aria-describedby="idle-warning-message">
  <div class="uw-dialog-header">
    <h1 class="uw-dialog-heading" id="idle-warning-title">{{ "idle_timeout.title" | translate }}</h1>
  </div>

  <div class="uw-dialog-content">
    <p id="idle-warning-message">{{ "idle_timeout.message" | translate }}</p>
    <p class="idle-warning-countdown">
      {{ "idle_timeout.countdown" | translate }} <strong>{{ timeRemaining$ | async }}</strong>
    </p>
  </div>

  <div class="uw-dialog-footer">
    <div class="uw-actions">
      <button class="uw-default-button" cdkFocusInitial (click)="close('stay')">
        {{ "idle_timeout.stay_logged_in" | translate }}
      </button>

      <button class="uw-stroked-button" (click)="close('logout')">
        {{ "sidebar.log_out" | translate }}
      </button>
    </div>
  </div>
</div>
